import React, { useRef, useEffect } from 'react';
import Slider from 'react-slick';
import Typography from '../../../components/atoms/Typography';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { get, isEmpty } from 'lodash';
import Box from '../../../components/molecules/Box';
import Container from '../../../components/molecules/Container';
import Grid from '../../../components/molecules/Grid';
import clsx from 'clsx';
import 'slick-carousel/slick/slick.css';
import '../../../../styles/themes/slick-themes.css';
import useStyles from '../../../components/organism/SharedMultiCardcontent/style';
import Hidden from '@material-ui/core/Hidden';
import CarouselCard from '../../../components/molecules/CarouselCard';
import { settings } from './config';
import Button from '../../../components/atoms/Button';
import { NoSsr, useMediaQuery } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { pushAnaylyticsData } from '../../../../../src/utils/analytics';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import { EVENT_TYPE } from '../../../../constants/index';
import useStyleOfComponent from './style';
import aspectRatios from '../../../utils/AspectRatios';
import { createDynamicLabels } from '../../../../utils/analytics';
import { transformLink } from '../../../../utils/utility';

const SharedSimilarSearchContent = props => {
  const {
    cardList,
    title,
    description,
    ctaLink,
    variation,
    pageContentType,
    aspectRatioNeeded = false,
    pageName,
    forcedRatio,
    componentName,
    language = 'en'
  } = get(props, 'fields', '');
  const { ratio = '3x2-card', totalLimit = 20 } = props;
  let configSettings = { ...settings };
  const { hasFavouriteBasket = false, isADRelatedEvents = false } = props;
  const transformedCtaLink = transformLink(ctaLink)
  const btnText = isADRelatedEvents
    ? get(props, 'fields.ctaLink.value.text', '')
    : get(description, 'value', 'See More');
  const classes = useStyles(props);
  const componentClasses = useStyleOfComponent({ pageContentType });
  const theme = useTheme();
  const isRTL = theme && theme.direction === 'rtl';
  const sharedSimilarSearchWrapper = useRef(null);
  const isMobile = useMediaQuery(`(max-width:${1023}px)`);
  const slideToShow = settings.slidesToShow
  const sliderRef = useRef()

  configSettings = {
    ...settings,
    slidesToShow: isADRelatedEvents ? 3 : settings.slidesToShow,
    rtl: isRTL,
    initialSlide: isRTL ? 2 : 0,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: isADRelatedEvents ? 2 : settings.slidesToShow,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          initialSlide: isRTL ? cardList && cardList.length - 1 : 0,
          slidesToShow: isADRelatedEvents ? 2 : settings.slidesToShow,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '27px',
          arrows: false,
          useTransform: false,
          useCSS: false,
          touchMove: false,
        },
      },
      {
        breakpoint: 767,
        settings: {
          initialSlide: isRTL ? cardList && cardList.length - 1 : 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '27px',
          arrows: false,
          useTransform: false,
          useCSS: false,
          touchMove: false,
        },
      },
    ],
  };

  useEffect(() => {
    if (isRTL) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(sliderRef.current.props.children.length);
      }, 2000);
    }
  }, [])
  const addAnalyticsInfo = () => {
    const obj = {
      ...analyticsData.pageBodyInteraction.arrowClick,
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          `${title && title.value} - ${btnText}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  const addSwipeAnalyticsInfo = () => {
    const obj = {
      ...analyticsData.pageBodyInteraction.swipeArrowClick,
      ...{
        label: createDynamicLabels([
          pageName,
          componentName,
          `${title && title.value}`,
        ]),
      },
    };
    pushAnaylyticsData(obj);
  };
  const getHeadingContent = () => {
    return (
      <Grid data-locator={props['data-locator']}>
        <div
          className={clsx(
            (variation === 'MoreLikeThis' || variation === 'RelatedEvents') && btnText && classes.descriptionType3 && 'titleContainer'
          )}
        >
          {title && title.value && (
            <Typography
              variant={isADRelatedEvents ? 'h5' : 'h2'}
              className="main-heading"
              component="h2"
              gutterBottom={true}
            >
              <Text field={title} />
            </Typography>
          )}
          {(variation === 'MoreLikeThis' || variation === 'RelatedEvents') && (
            <Hidden mdDown implementation="css">
              {btnText && (
                <Button
                  onClick={addAnalyticsInfo}
                  component="span"
                  className={variation === 'RelatedEvents' ? classes.relatedEventsCTA : ""}
                  buttonType={variation === 'RelatedEvents' ? "default" : "primary"}
                  field={transformedCtaLink}
                >
                  {btnText}
                </Button>
              )}
            </Hidden>
          )}
        </div>
      </Grid>
    );
  };
  // const filteredCardList =
  //   cardList &&
  //   cardList.length > 0 &&
  //   cardList.filter(
  //     item =>
  //       get(item, 'fields.title.value', '') &&
  //       get(item, 'fields.desktopImage.value.src', '')
  //   );

  const handleScroll = () => {
    if (!isMobile) return
    const index = cardList.length
    const carouseLastCard = document.getElementById(`searchId-${index}`)?.getBoundingClientRect()
    if (!carouseLastCard) return
    const scrollThreshold = isRTL ? 200 : (carouseLastCard.width + 500);
    const loadMoreCard = isRTL ? carouseLastCard.right > scrollThreshold : carouseLastCard.right < scrollThreshold
    // console.log('searchId', `searchId-${index}`, 'Right', carouseLastCard.right)
    if (loadMoreCard) {
      props.getCurrentIndex(index)
    }
  }

  const getURLWithLanguage = (originalURL = '') => {
    if (isADRelatedEvents && language && typeof language == 'string') {
      return `/${language}${originalURL}`;
    }

    return originalURL;
  }

  return (
    <Box
      component="div"
      onScroll={() => handleScroll()}
      className={clsx(
        classes.root,
        'Type3', // Because in more like this and other branches both the scenario requires arrow to above of the card unlike on the image
        isRTL && componentClasses.rtlClass,
        componentClasses.root,
        !btnText && 'no-cta',
        isADRelatedEvents && 'ADrelatedEvents'
      )}
      ref={sharedSimilarSearchWrapper}
    >
      <Container>{getHeadingContent()}</Container>
      <NoSsr>
        {cardList && cardList.length > 0 && (
          <Slider
            ref={sliderRef}
            afterChange={(currentIndex) => {
              addSwipeAnalyticsInfo()
              if (isMobile) return
              const indexCalc = isRTL ? (totalLimit - currentIndex) : currentIndex + slideToShow
              if (props.getCurrentIndex) props.getCurrentIndex(indexCalc)
            }}
            {...configSettings}
          >
            {cardList.filter((_, i) => i < totalLimit).map((item, index) => {
              return (
                <div
                  id={`searchId-${index + 1}`}
                  key={item}
                  className={
                    !aspectRatioNeeded &&
                      get(item, 'fields.desktopImage.value.src', '') === null ?
                      componentClasses.fallback : ''
                  }
                >
                  <CarouselCard
                    title={get(item, 'fields.title.value', '')}
                    desktopImage={get(item, 'fields.desktopImage', '')}
                    mobileImage={get(item, 'fields.mobileImage', '')}
                    ctaLink={get(item, 'fields.attributeLabelCTA', [])}
                    imageCtaUrl={getURLWithLanguage(get(item, 'fields.primaryCTA.value.href', ''))}
                    startDate={get(item, 'fields.startDate', '')}
                    locationTitle={get(item, 'fields.locationTitle.value', '')}
                    region={get(item, 'fields.region.value', '')}
                    endDate={get(item, 'fields.endDate', '')}
                    openTime={get(item, 'fields.openTime', '')}
                    closeTime={get(item, 'fields.closeTime', '')}
                    googlePlacesAPI={get(props, 'fields.appConfig.GOOGLE_PLACES_API', '')}
                    umbrellaEventCount={get(
                      item,
                      'fields.umbrellaEventCount',
                      ''
                    )}
                    bgColor={get(item, 'fields.backgroundColor.value', '')}
                    cardType={
                      isADRelatedEvents ? 'event' : pageContentType === EVENT_TYPE ? EVENT_TYPE : 'listing'
                    }
                    eventType={get(item, 'fields.eventType', '')}
                    location={get(item, 'fields.location', '')}
                    pageContentType={pageContentType}
                    sectionTitle={title}
                    aspectRatio={aspectRatios[ratio]}
                    aspectRatioNeeded={aspectRatioNeeded}
                    pageName={pageName}
                    componentName={isADRelatedEvents ? 'SmartListSlider' : componentName}
                    urlSlug={get(item, 'fields.urlSlug', '')}
                    expenseRange={get(item, 'fields.expenseRange', '')}
                    viewsCount={get(item, 'fields.viewsCount', '')}
                    rating={get(item, 'fields.rating', '')}
                    num_reviews={get(item, 'fields.num_reviews', '')}
                    rating_image_url={get(item, 'fields.rating_image_url', '')}
                    googlePlaceId={get(item, 'fields.googlePlaceId', '')}
                    itemUniqueKey={get(item, 'fields.itemUniqueKey', '')}
                    forcedRatio={forcedRatio}
                    showFavoriteIcon={hasFavouriteBasket}
                    showLoader={isEmpty(item)}
                    eventCategories={''}
                  />
                </div>
              );
            })}
          </Slider>
        )}
      </NoSsr>
      {(variation === 'MoreLikeThis' || variation === 'RelatedEvents') && (
        <Hidden lgUp implementation="css">
          {btnText && (
            <Box component="div" px={3}>
              <Button
                onClick={addAnalyticsInfo}
                component="span"
                className={variation === 'RelatedEvents' ? classes.relatedEventsCTA : ""}
                buttonType={variation === 'RelatedEvents' ? "default" : "primary"}
                field={ctaLink}
              >
                {btnText}
              </Button>
            </Box>
          )}
        </Hidden>
      )}
    </Box>
  );
};

export default SharedSimilarSearchContent;
